/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from 'axios'
import { Result } from '../../../Shared/Protocol/protocol-result'
import {
  ICreateProductMaskOptionPayload,
  IDecodeProductMaskPayload,
  IDecodeProductMaskResponse,
  IListProductMaskOptionsPayload,
  IUpdateProductMaskOptionPayload,
  TProductMaskOptionsApiResponse,
} from './product-mask-options.interface'

export class ProductMaskOptionsApiRemoteService {
  constructor(private service: AxiosInstance) {}

  private normalizePayload = (data: Partial<ICreateProductMaskOptionPayload> & { isActive?: boolean }) => {
    const category = data.category || data.type
    const label = data.name

    return {
      ...data,
      category,
      label,
      type: undefined,
      name: undefined,
    }
  }

  public list = async ({ isActive }: IListProductMaskOptionsPayload = {}): Promise<Result<TProductMaskOptionsApiResponse>> => {
    try {
      const response = await this.service.get('/product-mask-options', {
        params: typeof isActive === 'boolean' ? { isActive } : undefined,
      })

      return Result.ok(response.data)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public create = async (data: ICreateProductMaskOptionPayload): Promise<Result<void>> => {
    try {
      await this.service.post('/product-mask-options', this.normalizePayload(data))

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public update = async ({ id, ...data }: IUpdateProductMaskOptionPayload): Promise<Result<void>> => {
    try {
      const payload = this.normalizePayload(data)

      await this.service.put(`/product-mask-options/${encodeURIComponent(id)}`, {
        params: { id },
        ...payload,
      })

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public destroy = async (id: string): Promise<Result<void>> => {
    try {
      await this.service.delete(`/product-mask-options/${encodeURIComponent(id)}`)

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public decode = async (data: IDecodeProductMaskPayload): Promise<Result<IDecodeProductMaskResponse>> => {
    try {
      const response = await this.service.post('/product-mask-options/decode', data)

      return Result.ok(response.data)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }
}
